import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { FadeLoader } from 'react-spinners';
import './LoadingModal.css';

const LoadingModal = (props) => {
    return (
        <Modal
            id="loadingModal"
            show={props.show}
            backdrop='static'
            size='sm'
            centered>
            <Modal.Body>
                <Row className="justify-content-md-center mt-5">
                    <Col xs='auto' className="p-0 ml-2">
                        <FadeLoader
                            height={15}
                            width={5}
                            radius={2}
                            margin={"3px"}
                            color={'#FFFFFF'}
                            loading={true}
                        />
                    </Col>
                </Row>          
            </Modal.Body>
        </Modal>
    );
}
export default LoadingModal